import CustomBreadcrumbs from '@/custom/components/atoms/CustomBreadcrumbs'
import privacyBanner from '../../assets/images/privacy-policy-banner.jpg'
import React from 'react'
import './StaticPages.css'
const PrivacyPolicy = () => {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Privacy Policy', link: '/privacy_policy' },
    ]
    return (
        <div className="content-wrapper">
            <div className="main-content">
                <div className="header-banner">
                    <div className="banner-image">
                        <img src={privacyBanner} alt="Privacy Banner" className="banner-img" />
                    </div>
                    <div className="banner-summary">
                        <div className="banner-text">
                            <h2>Privacy Policy</h2>
                        </div>
                    </div>
                </div>
                <div className="nav-trail">
                    <div className="trail-container">
                        <CustomBreadcrumbs items={breadcrumbs} />
                    </div>
                </div>
                <div className="info-container">
                    <div className="info-box">
                        <h5>
                            <strong>1. Context</strong>
                        </h5>
                        <div className="info-section spaced">
                            <h6>
                                <strong>1.1. What is iQuippo?</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    This website{' '}
                                    <a href="https://iquippo.com/">https://iquippo.com/</a> and the
                                    associated mobile apps (together referred to as the “Platform”,
                                    is an internet-based portal, owned and operated by iQuippo
                                    Services Pvt. Ltd., a company duly incorporated under the
                                    provisions of the Companies Act, 2013 (hereinafter referred to
                                    as “iQuippo” or “Company” or “We” or “Our” or “Us”). The Company
                                    is engaged inter alia, in the business of developing and
                                    operating a platform for providing 360 degrees solution to
                                    banks, financial institutions, manufacturers, dealers, business
                                    entities etc. to, inter alia, provide services like sourcing the
                                    borrower, facilitation with loan process, analysis of the
                                    borrower through its risk engine, lease rental products,
                                    valuation, facilitating the insurance products, collections sale
                                    and purchase of repossessed assets through online auctions and
                                    other related asset/equipment lifecycle services, including but
                                    not limited to acquisition, disposal, maintenance, operations
                                    and logistics. (the “Services”).
                                </li>
                                <li>
                                    The Company owns and operates the Platform, providing details
                                    about the Company and the Services offered by it. Through the
                                    Platform, customers may submit a request to know more about the
                                    Services by entering their name, email address, phone number and
                                    other Personal Information (as defined hereinafter). The Company
                                    is committed to protect the customers’ privacy and ensure that
                                    they have a positive experience on the Platform.
                                </li>
                                <li>
                                    The Company can be reached, for all questions and directions
                                    related to this privacy policy (the “Privacy Policy”), by:
                                    <ul className="list-style-a">
                                        <li>
                                            Sending a letter marked to the attention of customer
                                            care, IPCL Building, Plot No. Tangra Industrial Estate,
                                            Phase - II,45 Radhanath Chowdhury Road Kolkata - 700015
                                            to iQuippo Services Limited; or
                                        </li>
                                        <li>Sending an email to: customercare@iquippo.com.</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>1.2. What is this Privacy Policy?</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    This Privacy Policy describes the Company’s policies and
                                    procedures on the collection, storage, processing, use,
                                    dissemination and disclosure of information provided by the end
                                    users either directly or indirectly, and the visitors of the
                                    Platform. (together referred to as the “Users”). The Company
                                    shall not use the User’s information in any manner except as
                                    provided under this Privacy Policy. Every User who accesses or
                                    uses the Platform agrees to be bound by the terms of this
                                    Privacy Policy and terms of service.
                                </li>
                                <li>
                                    <strong>Interpretation:</strong> In this Privacy Policy,
                                    references to “You”, “Your”, “User” shall mean the end user
                                    accessing the Platform and or the Services and “We”, “Us” and
                                    “Our” shall mean the Company, its affiliates and partners.
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>1.3. Why this Privacy Policy?</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    This Privacy Policy is published and is in compliance of the
                                    Information Technology (Intermediaries Guidelines) Rules, 2011
                                    under the Information Technology Act, 2000 and all other
                                    applicable laws that require us to publish this Privacy Policy.
                                </li>
                                <li>
                                    <strong>Interpretation:</strong> In this Privacy Policy,
                                    references to “You”, “Your”, “User” shall mean the end user
                                    accessing the Platform and or the Services and “We”, “Us” and
                                    “Our” shall mean the Company, its affiliates and partners.
                                </li>
                                <li>
                                    This Privacy Policy states the following
                                    <ul className="list-style-a">
                                        <li>
                                            The type of information collected, directly or
                                            indirectly, from the visitors of the Platform and the
                                            Users, including Personal Information (as defined
                                            hereinafter);
                                        </li>
                                        <li>
                                            The purpose, means and modes of usage of such
                                            information; and
                                        </li>
                                        <li>
                                            How and to whom the Company will disclose such
                                            information.
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>1.4. What is Personal Information?</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    <strong>“Personal Information”</strong> means any data or
                                    information that relates to a natural person, which, either
                                    directly or indirectly, whether available online or offline, or
                                    in combination with any other information likely to be available
                                    with a body corporate, is capable of identifying such natural
                                    person.
                                </li>
                                <li>
                                    Information that is freely available in the public domain or
                                    accessible under the Right to Information Act, 2005 or any other
                                    law will not be regarded as Sensitive Personal Information (as
                                    defined hereinafter).
                                </li>
                            </ul>
                        </div>
                        <h5>
                            <strong>2. Privacy Statements</strong>
                        </h5>
                        <div className="info-section spaced">
                            <h6>
                                <strong>2.1 All Users Note</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    This section of the Privacy Policy applies to all visitors and
                                    Users.
                                </li>
                                <li>
                                    Accordingly, a condition of each User’s use of and access to the
                                    Platform and to the Services is their acceptance of the terms of
                                    use available at{' '}
                                    <a href="https://iquippo.com/">https://iquippo.com/</a> (the{' '}
                                    <strong>“Terms of Use”</strong>), which also involves acceptance
                                    of the terms of this Privacy Policy. Any User that does not
                                    agree with any provisions of the same is required to leave the
                                    Platform immediately.
                                </li>
                                <li>
                                    Except as otherwise provided in paragraph 2.1.vi , when browsing
                                    the Platform, a User is not required to provide Personal
                                    Information unless and until such User chooses to submit his/
                                    her Personal Information in the Platform.
                                </li>
                                <li>
                                    Due to the communications standards on the internet, when a User
                                    visits the Platform, the Company automatically receives the
                                    uniform resource locator <strong>(“URL”)</strong> of the site
                                    from which such User came and the site to which such User is
                                    going when he/ she/ it leaves the Platform. The Company also
                                    receives the Internet Protocol <strong>(“IP”)</strong> address
                                    of each User’s computer (or the proxy server a User used to
                                    access the internet), the User’s computer operating system and
                                    type of web browser the User is using, email patterns, as well
                                    as the name of User’s internet service provider{' '}
                                    <strong>(“ISP”)</strong>. This information is used to analyze
                                    overall trends to help the Company improve its’ Services. The
                                    linkage between User’s IP address and User’s Personally
                                    Identifiable Information is not shared with third parties
                                    without such User’s permission or except when required by law or
                                    except where required to provide or facilitate the Services.
                                </li>
                                <li>
                                    Notwithstanding the above, the User acknowledges the Company’s
                                    right and expressly authorizes the Company to share some of the
                                    aggregate findings (not the specific data) with advertisers,
                                    sponsors, investors, strategic partners, and others for
                                    promotional purposes. The User also agrees to be contacted via
                                    email, call and/or SMS in relation to the Services provided
                                    through the Platform for imparting knowledge of its products,
                                    promotional offers and various other offers. However, we do
                                    respect your right to ask us not to do so. We do not sell your
                                    Personal Information to anyone in a way other than as set forth
                                    in this Privacy Policy.
                                </li>
                                <li>
                                    The Platform uses temporary cookies to store certain data (that
                                    is not Sensitive Personal Information) that is used by the
                                    Company and its service providers for the technical
                                    administration of the Platform’s research and development, and
                                    for User administration. In the course of serving advertisements
                                    or optimizing services to its Users, the Company may allow
                                    authorized third parties to place or recognize a unique cookie
                                    on the User’s browser. The Company does not store Personal
                                    Information in the cookies.
                                </li>
                                <li>
                                    The Company may keep records of Personal Information received
                                    from the Users as well as the telephone calls received from and
                                    made for making appointments or other purposes for the purpose
                                    of administration of Services, marketing, analytics, research
                                    and development and for User administration.
                                </li>
                                <li>
                                    The Platform may enable User to communicate with other Users or
                                    to post information to be accessed by others, whereupon other
                                    Users may collect such data. The Company hereby expressly
                                    disclaims any liability for any misuse of such information that
                                    is made available by Users in such a manner.
                                </li>
                                <li>
                                    The Company does not collect information about the Users of the
                                    Platform from other sources, such as public records or bodies,
                                    or private organisations, save and except as provided in this
                                    Privacy Policy.
                                </li>
                                <li>
                                    The Company does not collect information about the Users of the
                                    Platform from other sources, such as public records or bodies,
                                    or private organisations, save and except as provided in this
                                    Privacy Policy.
                                </li>
                                <li>
                                    government, computer hacking, unauthorized access to computer
                                    data and storage device, computer crashes, breach of security
                                    and encryption, etc.
                                </li>
                                <li>
                                    All communications between the computer browser and the Platform
                                    that contain Personal Information are encrypted. This enables
                                    the client and server applications to communicate in a manner
                                    that is designed to prevent eavesdropping, tampering and message
                                    forgery.
                                </li>
                                <li>
                                    The Company will not disclose any Personal Information or data
                                    to governmental institutions or authorities unless such
                                    disclosure is requisitioned under any Indian law or judicial
                                    decree or when the Company, in its sole discretion, deems it
                                    necessary in order to protect its rights or the rights of
                                    others, to prevent harm to persons or property, to fight fraud
                                    and credit risk, or to enforce or apply our Terms of Use.
                                </li>
                                <li>
                                    The User is responsible for maintaining the security of the
                                    login id and password and should not provide the credentials to
                                    any third party. In the event, there is a reason to believe that
                                    the information is known to any third party, the User should
                                    contact the Company immediately. Under any circumstances, the
                                    Company is not responsible for any unauthorised access to the
                                    User’s account. However, if the User has a security related
                                    concern the Company shall work closely with the User to ensure a
                                    quick and personal response to the User’s concerns.
                                </li>
                                <li>
                                    The Company does not take any responsibility for the
                                    transmission of information you provide to us, given the nature
                                    of transactions that take place over the internet. Any
                                    transmission of your information on the internet is done at your
                                    risk.
                                </li>
                                <li>
                                    The Company does not take any responsibility for you or any
                                    third party circumventing the privacy settings or security
                                    measures contained on the Platform.
                                </li>
                                <li>
                                    We do not knowingly collect Personal Information from minor
                                    children. If we learn that we have collected Personal
                                    Information from a child who are in the minor category, we will
                                    delete that information from our database.
                                </li>
                                <li>
                                    The Company shall address any discrepancies and grievances of
                                    all Users with respect to processing of information in a time
                                    bound manner. For this purpose, the Company has designated{' '}
                                    <strong>Mr. Gaurav Sharma</strong> as the &#39;grievance
                                    officer&#39;, who will redress the grievances of the Users
                                    expeditiously but within a reasonable time from the date of
                                    receipt of grievance, and who can be reached by:
                                    <ul className="list-style-a">
                                        <li>
                                            Sending a letter marked to the attention of{' '}
                                            <strong>Mr. Gaurav Sharma</strong> to iQuippo Services
                                            Pvt. Ltd., 14A, 6th Floor, Sector 18, Maruti Industrial
                                            Complex, Gurugram, Haryana - 122015
                                        </li>
                                        <li>Sending an email to customercare@iquippo.com.</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>2.2 Visitors Note:</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    No Sensitive Personal Information is automatically collected by
                                    the Company from any casual visitors of this Platform, who are
                                    merely perusing or browsing the Platform, except as otherwise
                                    provided in 2.1v.
                                </li>
                                <li>
                                    Nevertheless, certain provisions of this Privacy Policy are
                                    applicable to even such casual visitors, and such casual
                                    visitors are also required to read and understand the privacy
                                    statements set out herein, failing which they are required to
                                    leave this Platform immediately.
                                </li>
                                <li>
                                    If you, as a casual visitor, have inadvertently browsed any
                                    other pages of this Platform prior to reading the privacy
                                    statements set out herein, and you do not agree with the manner
                                    in which such information is obtained, stored or used, merely
                                    quitting this browser application should ordinarily clear all
                                    temporary cookies installed by the Company. All visitors,
                                    however, encouraged to use the “clear cookies” functionality of
                                    their browsers to ensure such clearing/ deletion, as the Company
                                    cannot guarantee, predict or provide for the behaviour of the
                                    equipment of all the visitors of the Platform.
                                </li>
                                <li>
                                    You are not a casual visitor if you have willingly submitted any
                                    Personal Information to the Company through any means, including
                                    but not limited to email or through any post on the Platform.
                                    All such visitors will be deemed to be, and will be treated as,
                                    Users for the purposes of this Privacy Policy, and in which
                                    case, all the statements in this Privacy Policy apply to such
                                    persons.
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>2.3 Collection Process:</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    The Company will collect the following types of information from
                                    you:
                                    <ul className="list-style-a">
                                        <li>
                                            “Personally Identifiable Information” – Personal
                                            Information that could be used to identify you such as,
                                            your name, email, address, age, gender, IP addresses and
                                            other similar information;
                                        </li>
                                        <li>
                                            “Sensitive Personal Information” means such Personal
                                            Information, which may reveal, be related to, or
                                            constitute:
                                            <ul>
                                                <li>passwords;</li>
                                                <li>
                                                    financial data such as bank accounts, credit and
                                                    debit card details, payment instrument details,
                                                    relationship with a financial institution,
                                                    financial status and credit history;
                                                </li>
                                                <li>sexual orientation and sex life;</li>
                                                <li>genetic data;</li>
                                                <li>transgender status;</li>
                                                <li>intersex status;</li>
                                                <li>caste or tribe;</li>
                                                <li>
                                                    health data, which includes data related to
                                                    physical, physiological and mental health and
                                                    condition, medical records and history;
                                                </li>
                                                <li>
                                                    biometric information, such as facial images,
                                                    fingerprints, iris scans, or any other similar
                                                    Personal Information;
                                                </li>
                                                <li>
                                                    information received by body corporate under
                                                    lawful contract or otherwise;
                                                </li>
                                                <li>
                                                    official identifier, means any number code, or
                                                    other identifier assigned to a natural person by
                                                    the government, which may be used to verify the
                                                    identity of such natural person; and
                                                </li>
                                                <li>
                                                    any other Personal Information categorised as
                                                    Sensitive Personal Information by the
                                                    government.
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            “Non-Personal Information” – information that cannot be
                                            used to identify you such as the webpages that you have
                                            viewed, your usage patterns and cookies;
                                        </li>
                                        <li>
                                            “Device Information” – information which is
                                            automatically collected about the device from which the
                                            Platform is accessed/used.
                                        </li>
                                        <li>
                                            “Log Files” - this information may include internet
                                            protocol (IP) addresses, browser type, internet service
                                            provider (ISP), referring/exit pages, operating system,
                                            date/time stamp, and/or clickstream data;
                                        </li>
                                        <li>
                                            Any other information that the User may provide; and
                                        </li>
                                        <li>
                                            Any information about the User that is available on the
                                            public domain and is retrieved by us.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    The information specified in clause 2.3.i above is collected for
                                    reasons including but not limited to, (i) personal
                                    identification, (ii) to allow the Company to contact the User
                                    for customer service and business development purposes, (iii) to
                                    customize the content of the Platform to meet specific needs of
                                    the User and improve customer experience, (iv) to make
                                    improvements to the Platform for upsell and promotion, (v)
                                    predictive analytics, (vi) customer credit profiling and/or
                                    (vii) a perspective analysis of the Platform based on customers
                                    collected data.
                                </li>
                                <li>
                                    The User may also receive updates about special offers, new
                                    services, and other noteworthy events. However, the User may, at
                                    any time choose to no longer receive such types of emails. For
                                    further details, please refer to clause 2.4 of this Privacy
                                    Policy.
                                </li>
                                <li>
                                    Your data will be stored in our secured servers will be shared
                                    only with concerned individuals and/ or legal entities, post
                                    obtaining explicit consent from you. Provided however, no
                                    consent or authorization shall be obtained from you for merging/
                                    transferring your transaction/ profile data into another
                                    server(s), including, but not limited to, such other usage as
                                    may be required to ensure its safety. Such merged/ transferred
                                    data may further be used to show suitable information to the
                                    Users, which we, in our sole opinion may deem useful for
                                    providing efficient Services to the Users.
                                </li>
                                <li>
                                    Your data including your customer score, status of application
                                    and decision support memo with financier and application
                                    information collected shall be disseminated to our partners
                                    (financier, channel partners, dealers, manufacturers etc.)
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>2.4 Access of Information:</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    All the information of the Users, including Personal
                                    Information, either provided by the Users and/or procured from
                                    public sources (the “User Information”) is maintained by the
                                    Company in electronic form on online servers/ cloud systems and
                                    shall be accessible by certain employees of the Company as
                                    mentioned below. The User Information may also be converted to
                                    physical form from time to time. Regardless of the manner of
                                    storage, the Company will keep all User Information
                                    confidential, and will only disclose User Information to the
                                    persons mentioned below:
                                    <ul className="list-style-a">
                                        <li>
                                            Its employees on a need-to-know basis. All the Company
                                            employees and data processors, who have access to, and
                                            are associated with the processing of User Information,
                                            are obliged to respect the confidentiality of User
                                            Information.
                                        </li>
                                        <li>
                                            Third party service providers to the extent necessary to
                                            provide the Users with the Service. The Company may
                                            provide the User Information to third party service
                                            providers to work on behalf of or with the Company to
                                            provide the Users with the Service, to help the Company
                                            communicate with the Users or to maintain the Platform.
                                            Generally, the third-party service providers do not have
                                            any independent right to share this information, however
                                            certain service providers who provide services on the
                                            Portal, including the providers of online communications
                                            services, will have rights to use and disclose the User
                                            Information collected in connection with the provision
                                            of these services in accordance with their own privacy
                                            policies
                                        </li>
                                        <li>
                                            Notwithstanding the above, the Company shall not
                                            responsible for any breach of security or for any
                                            actions of any third parties that receive the User
                                            Information or events that are beyond the reasonable
                                            control of the Company including, acts of government,
                                            computer hacking, unauthorised access to computer data
                                            and storage device, computer crashes, breach of security
                                            and encryption, etc.
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>
                                    2.5 Intimation by Customers Regarding Change in Personal
                                    Information
                                </strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    If your personal information provided to us when you had applied
                                    for a product on our Platform changes, you may update it
                                    whenever you apply for a new product via our Platform. To review
                                    and update your personal information and to ensure that the same
                                    is accurate while your application is in process, you may
                                    contact us at help@iquippo.com. You will not be able to update
                                    the information you have provided in an application after a
                                    decision has already been made on it; however, you may create
                                    and submit a new application with your updated information.
                                </li>
                                <li>
                                    We will retain your information for as long as your account is
                                    active or as needed to provide you Services. If you wish to
                                    cancel your account or request that we no longer use your
                                    information to provide you Services, contact us at
                                    help@iquippo,com. We will respond to your request within a
                                    reasonable timeframe. However, we will retain and use your
                                    information as necessary to comply with our legal obligations,
                                    resolve disputes, and to enforce our agreements.
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>2.6 Additional Policy Information:</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    Single Sign-On: The User can log in to the Platform using
                                    sign-in services such as Facebook, Twitter and LinkedIn Connect
                                    or an Open ID provider. These services will authenticate User’s
                                    identity and provide the option to share certain personal
                                    information with the Company such as the User’s sign-in
                                    information, name and email address to link between the
                                    websites. Social networking media services like Facebook and
                                    Twitter give the Users the option to post information about the
                                    User’s activities on the Platform to the User’s profile page to
                                    share with others within the User’s network.
                                </li>
                                <li>
                                    Links to third party websites on the Platform or any other links
                                    or widgets of third party websites, may include links to other
                                    websites whose privacy practices may differ from those of the
                                    Company. If the User submits personal information to any of
                                    those websites, the User’s information will be governed by the
                                    privacy policy of such website(s). We encourage the Users to
                                    carefully read the privacy policy of any website the Users
                                    visit. If you wish to not have this information used for the
                                    purpose of serving you interest-based ads, you may opt-out by
                                    clicking here. Please note this does not opt you out of being
                                    served ads. You will continue to receive generic ads.
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>2.7 Opt-out Policy:</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    The subsidiaries and third party service providers with whom the
                                    Company may share Personal Information provided by the Users are
                                    not permitted to market their own services or send promotional
                                    e-mails to the Users, unless they become customers of the third
                                    parties. The Company provides all the Users with the opportunity
                                    to opt-out of receiving non-essential, promotional, or
                                    marketing-related communication from itself or its partners.
                                    These settings can be found on the Platform or will be informed
                                    separately by the Company.
                                </li>
                                <li>
                                    If a User wishes to rectify or remove their data or any part
                                    thereof, the User may contact the Company at help@iquippo.com.
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>Indemnity and Limitation of Liability</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    It is agreed that You will indemnify and hold the Company, any
                                    and all of its officers, subsidiaries, affiliates, successors,
                                    assigns, directors, officers, agents, service providers,
                                    suppliers and employees, at all times, harmless from any claim
                                    or demand, including reasonable attorney fees and court costs,
                                    made by any third party due to or arising out of content you
                                    submit, post or make available through the Service, your use of
                                    the Services, your violation of the terms, your breach of any of
                                    the representations and warranties herein, or your violation of
                                    any rights of another.
                                </li>
                                <li>
                                    We shall not be liable for any loss or damage, including without
                                    limitation direct or indirect, special, economic, incidental, or
                                    consequential damages, losses or expenses arising in connection
                                    with this Platform or use thereof or inability to use by any
                                    party, or in connection with any failure of performance, error,
                                    omission, interruption, defect, delay in operation or
                                    transmission, computer virus or line or system failure, even if
                                    we have been advised of the possibility of such damages, losses
                                    or expenses.
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>Disclaimer</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    We do not ensure that the information on this Platform is
                                    correct, we do not warrant its completeness or accuracy; nor do
                                    we promise to ensure that the Platform remains available or that
                                    the material on the Platform is kept up to date. To the maximum
                                    extent permitted by applicable law, we exclude all
                                    representations, warranties and conditions relating to our
                                    Platform and the use of this Platform. Nothing in this
                                    disclaimer will:
                                    <ul className="list-style-a">
                                        <li>
                                            Limit or exclude our or your liability for death or
                                            personal injury;
                                        </li>
                                        <li>
                                            Limit or exclude our or your liability for fraud or
                                            fraudulent misrepresentation;
                                        </li>
                                        <li>
                                            Limit any of our or your liabilities in any way that is
                                            not permitted under applicable law;
                                        </li>
                                        <li>
                                            Exclude any of our or your liabilities that may not be
                                            excluded under applicable law.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    The limitations and prohibitions of liability set in this
                                    section and elsewhere in this disclaimer:
                                    <ul className="list-style-a">
                                        <li>Are subject to the preceding paragraph, and</li>
                                        <li>
                                            Govern all liabilities arising under the disclaimer,
                                            including liabilities arising in contract, in tort and
                                            for breach of duty.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    As long as the Platform and the information and Services on the
                                    Platform are provided free of charge, we will not be liable for
                                    any loss or damage of any nature.
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>Change to privacy policy</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    The Users acknowledge that this Privacy Policy is part of the
                                    Terms of Use and unconditionally agree that becoming a User of
                                    the Platform and its Services signifies their assent to this
                                    Privacy Policy. User’s visit and any dispute over privacy is
                                    subject to this policy and Terms of Use. The Company may update
                                    this Privacy Policy at any time, with or without advance notice.
                                    In the event there are significant changes in the way the
                                    Company treats User’s personally identifiable information, the
                                    Company will display a notice on the Platform or send Users an
                                    email, as provided for above. Unless stated otherwise, this
                                    current Privacy Policy applies to all information that the
                                    Company has about Users and their account. Notwithstanding the
                                    above, the Company shall not be required to notify the Users of
                                    any changes made to the Privacy Policy.
                                </li>
                                <li>
                                    If a User uses the Service after notice of changes have been
                                    sent to such User or published on the Platform, such User hereby
                                    provides his/ her/ its consent to the changed practices.
                                </li>
                            </ul>
                        </div>
                        <div className="info-section spaced">
                            <h6>
                                <strong>Users Obligations:</strong>
                            </h6>
                            <ul className="list-style-i">
                                <li>
                                    You must, at all times, respect the terms and conditions of the
                                    then-current Privacy Policy and the Terms of Use. This includes
                                    respecting all intellectual property rights which may belong to
                                    the Company’s third parties.
                                </li>
                                <li>
                                    You must not create or otherwise disseminate any information
                                    which may be deemed to be injurious, violent, offensive, racist
                                    or xenophobic or which may otherwise violate the purpose and
                                    spirit of the Company and its community of Users.
                                </li>
                                <li>
                                    You must not provide information to the Company and/ or other
                                    Users which you believe might be injurious or detrimental to
                                    your person, professional or social status.
                                </li>
                                <li>
                                    You must not send any information to us that constitutes a trade
                                    secret or is confidential or proprietary. We cannot agree to
                                    obligations of confidentiality or non-disclosure with regard to
                                    unsolicited information submitted to it. By submitting
                                    information or materials to us, you and anyone acting on your
                                    behalf, agree that any such information or materials will not be
                                    considered confidential or proprietary. We shall be under no
                                    obligation to return any information or materials to you. In no
                                    event shall we be limited or restricted from pursuing any
                                    investment opportunities with others.
                                </li>
                                <li>
                                    Any violation of this Privacy Policy may lead to the
                                    restriction, suspension or termination of your account by the
                                    Company, as we take these principles seriously and consider them
                                    to be the basis on which our Users adhere to the Company
                                    policies and the Services which it offers.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PrivacyPolicy
